export default "__VITE_ASSET__3WS2hycQ__"